import { render, staticRenderFns } from "./Spinners.vue?vue&type=template&id=8f711cd2&scoped=true&"
import script from "./Spinners.vue?vue&type=script&lang=js&"
export * from "./Spinners.vue?vue&type=script&lang=js&"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./Spinners.vue?vue&type=style&index=1&id=8f711cd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f711cd2",
  null
  
)

export default component.exports